import * as types from './types';

export const INITIAL_STATE = {
  status: types.SIGNALR_STATUS_DISCONNECTED,
  connectionTries: 0,
  error: null,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.SIGNALR_CONNECTING:
      return {
        ...state,
        status: types.SIGNALR_STATUS_CONNECTING,
        connectionTries: state.connectionTries + 1,
        error: INITIAL_STATE.error,
      };
    case types.SIGNALR_CONNECTION_FAILED:
      return {
        ...state,
        status: types.SIGNALR_STATUS_ERRORED,
        error: payload,
      };
    case types.SIGNALR_CONNECTED:
      return {
        ...state,
        status: types.SIGNALR_STATUS_CONNECTED,
        connectionTries: INITIAL_STATE.connectionTries,
      };
    case types.SIGNALR_DISCONNECTING:
      return {
        ...state,
        status: types.SIGNALR_STATUS_DISCONNECTING,
      };
    case types.SIGNALR_DISCONNECTED:
      return {
        ...state,
        status: types.SIGNALR_STATUS_DISCONNECTED,
      };

    case types.SIGNALR_ERRORED:
      return {
        ...state,
        status: types.SIGNALR_STATUS_ERRORED,
        error: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/api/SignalR/state/reducer.js